package org.example.zone360.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgb
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgba

///
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

enum class Palette(
    val hexLight: String,
    val rgbLight: Color.Rgb,
    val hexDark: String,
    val rgbDark: Color.Rgb,
) {
    Primary(
        hexLight = "#FB6F2A",
        rgbLight = rgb(r = 251, g = 111, b = 42),
        hexDark = "#35D593",
        rgbDark = rgb(r = 53, g = 213, b = 147),

        ),
    BarSelected(
        hexLight = "#FAA002",
        rgbLight = rgb(r = 250, g = 160, b = 2),
        hexDark = "#35D593",
        rgbDark = rgb(r = 53, g = 213, b = 147),

        ),
    Secondary(
        hexLight = "#C9F9CD",
        rgbLight = rgba(201, 249, 205, 1f),
        hexDark = "#35D593",
        rgbDark = rgb(r = 53, g = 213, b = 147),

        ),
    BodyBackground(
        hexLight = "#F4F4F4",
        rgbLight = rgb(r = 244, g = 244, b = 244),
        hexDark = "#0F0819",
        rgbDark = rgb(15, 8, 25),
    ),

    TableHeader(
        hexLight = "#E0E0E0",
        rgbLight = rgb(r = 224, g = 224, b = 224),
        hexDark = "#0F0819",
        rgbDark = rgb(15, 8, 25),
    ),
    SearchbarPlaceholder(
        hexLight = "#A4A4A4",
        rgbLight = rgb(r = 164, g = 164, b = 164),
        hexDark = "#F7F7FA",
        rgbDark = rgb(247, 247, 250)
    ),

    Error(
        hexLight = "#B7182B",
        rgbLight = rgb(183, 24, 43 ),
        hexDark = "#E24A61",
        rgbDark = rgb(226, 74, 97)
    ),
    DeleteRed(
        hexLight = "#D32F2F",
        rgbLight = rgba(211, 47, 47, 1f),
        hexDark = "#E24A61",
        rgbDark = rgb(226, 74, 97)
    ),
    Success(
        hexLight = "#23A971",
        rgbLight = rgba(35, 169, 113, 1f),
        hexDark = "#219B65",
        rgbDark = rgba(33, 155, 101, 1f)
    ),
    EditTextBorder(
        hexLight = "#D4D4D4",
        rgbLight = rgb(212, 212, 212),
        hexDark = "#B9BCC2",
        rgbDark = rgb(185, 188, 194)
    ),
    EditTextSupportText(
        hexLight = "#424242",
        rgbLight = rgb(66, 66, 66),
        hexDark = "#94979C",
        rgbDark = rgb(148, 151, 156)
    ),
    ParrotGreen(
        hexLight = "#DAFD5D",
        rgbLight = rgb(218, 253, 93),
        hexDark = "#DAFD5D",
        rgbDark = rgb(218, 253, 93),
    ),
    ButtonTextSupportive(
        hexLight = "#787878",
        rgbLight = rgb(120, 120, 120),
        hexDark = "#F7F7FA",
        rgbDark = rgb(247, 247, 250)
    ),
    Disabled(
        hexLight = "#F4F4F4",
        rgbLight = rgba(244, 244, 244, 1f),
        hexDark = "#252132",
        rgbDark = rgba(37, 33, 50, 1f)
    ),
    Black(
        hexLight = "#000000",
        rgbLight = Colors.Black,
        hexDark = "#000000",
        rgbDark = Colors.Black,
    ),
    White(
        hexLight = "#FFFFFF",
        rgbLight = Colors.White,
        hexDark = "#FFFFFF",
        rgbDark = Colors.White,
    ),
    Modal(
        hexLight = "#FFFFFF",
        rgbLight = Colors.White,
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    FadedBlack(
        hexLight = "#000000",
        rgbLight = rgba(0, 0, 0, 0.5f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    TechnicalCategoryBackground(
        hexLight = "#000000",
        rgbLight = rgba(0, 169, 157, 0.06f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    FitnessCategoryBackground(
        hexLight = "#000000",
        rgbLight = rgba(255, 95, 95, 0.06f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    TacticalCategoryBackground(
        hexLight = "#000000",
        rgbLight = rgba(167, 57, 213, 0.06f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    MentalCategoryBackground(
        hexLight = "#0082FF",
        rgbLight = rgba(0, 130, 255, 0.06f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    GoalKeeperCategoryBackground(
        hexLight = "#000000",
        rgbLight = rgba(3, 110, 167, 0.06f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    TechnicalCategoryBorder(
        hexLight = "#00A99D",
        rgbLight = rgba(0, 169, 157, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    FitnessCategoryBorder(
        hexLight = "#FF5F5F",
        rgbLight = rgba(255, 95, 95, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    TacticalCategoryBorder(
        hexLight = "#A739D5",
        rgbLight = rgba(167, 57, 213, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    MentalCategoryBorder(
        hexLight = "#0082FF",
        rgbLight = rgba(0, 130, 255, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    GoalKeeperCategoryBorder(
        hexLight = "#036EA7",
        rgbLight = rgba(3, 110, 167, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    ClubPerformanceText(
        hexLight = "#000000",
        rgbLight = rgba(136, 136, 136, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    CoachesTileRow(
        hexLight = "#000000",
        rgbLight = rgba(249, 252, 255, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    ViewButtonBackground(
        hexLight = "#E9F4FF",
        rgbLight = rgba(233, 244, 255, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    ViewText(
        hexLight = "#0082FF",
        rgbLight = rgba(0, 130, 255, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    SentButtonColor(
        hexLight = "#B1FDCD",
        rgbLight = rgba(177, 253, 205, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    SendButtonColor(
        hexLight = "#EFAD00",
        rgbLight = rgba(239, 173, 0, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    BoxShadowColor(
        hexLight = "#1E293B17",
        rgbLight = rgba(30, 41, 59, 0.09f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    CoachInfoTextColor(
        hexLight = "#1E293B",
        rgbLight = rgba(30, 41, 59, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    LightGrey(
        hexLight = "#CBD5E1",
        rgbLight = rgba(241, 245, 249, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    SearchBackground(
        hexLight = "#EFF2F5",
        rgbLight = rgba(239, 242, 245, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    SelectedSessionBackground(
        hexLight = "#F06D2D14",
        rgbLight = rgba(240, 109, 45, 0.08f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    SelectedSessionBackgroundBorder(
        hexLight = "#F06D2D14",
        rgbLight = rgba(240, 109, 45, 0.5f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    CoachDetailsBoxBorder(
        hexLight = "#E4E4E7",
        rgbLight = rgba(228, 228, 231, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    GreenShadeColor(
        hexLight = "#3ABF38",
        rgbLight = rgba(58, 191, 56, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    PositiveColor(
        hexLight = "#0FBA83",
        rgbLight = rgba(15, 186, 131, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    NegativeColor(
        hexLight = "#F7324C",
        rgbLight = rgba(247, 50, 76, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    NeutralColor(
        hexLight = "#FAA002",
        rgbLight = rgba(250, 160, 2, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    WaveBarColor(
        hexLight = "#64748B",
        rgbLight = rgba(100, 116, 139, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    TitleColor(
        hexLight = "#0F1629",
        rgbLight = rgba(15, 22, 41, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    FieldBackColor(
        hexLight = "#4A5059",
        rgbLight = rgba(74, 80, 89, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    AbsoluteGreen(
        hexLight = "#0FBA83",
        rgbLight = rgba(15, 186, 131, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    AbsoluteOrange(
        hexLight = "#FAA002",
        rgbLight = rgba(250, 160, 2, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    InfoIconColor(
        hexLight = "#646970",
        rgbLight = rgba(100, 105, 112, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    CoachHeaderDetails(
        hexLight = "#FDF4ED",
        rgbLight = rgba(253, 244, 237, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    CoachHeaderGradientOne(
        hexLight = "#FF8008",
        rgbLight = rgba(255, 128, 8, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    CoachHeaderGradientTwo(
        hexLight = "#FFC837",
        rgbLight = rgba(255, 200, 55, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    PlayerHeaderGradientOne(
        hexLight = "#214F2A",
        rgbLight = rgba(33, 79, 42, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    PlayerHeaderGradientTwo(
        hexLight = "#326E3E",
        rgbLight = rgba(50, 110, 62, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    PrimaryPosition(
        hexLight = "#02FFEC",
        rgbLight = rgba(2, 255, 236, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    PlayerSavePngDataBox(
        hexLight = "#002408",
        rgbLight = rgba(0, 36, 8, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    GrayBorder(
        hexLight = "#B0B3B7",
        rgbLight = rgba(176, 179, 183, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    GrayIcon(
        hexLight = "#3E5765",
        rgbLight = rgba(62, 87, 101, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    Grey(
        hexLight = "#808080",
        rgbLight = rgba(128, 128, 128, 1f),
        hexDark = "#000000",
        rgbDark = rgba(0, 0, 0, 0.5f),
    ),
    NotificationBar(
        hexLight = "#0000001F",
        rgbLight = rgba(0, 0, 0, 0.12f),
        hexDark = "#0000001F",
        rgbDark = rgba(0, 0, 0, 0.12f),
    ),
    SeasonActiveDot(
        hexLight = "#22C55E",
        rgbLight = rgb(34, 197, 94),
        hexDark = "#22C55E",
        rgbDark = rgb(34, 197, 94),
    ),

    SeasonSearchBackground(
        hexLight = "#F6F6F2",
        rgbLight = rgb(246, 246, 242),
        hexDark = "#252132",
        rgbDark = rgb(37, 33, 50),
    ),

    SeasonActiveCardBackground(
        hexLight = "#EBF7E8",
        rgbLight = rgb(235, 247, 232),
        hexDark = "#1F3A2A",
        rgbDark = rgb(31, 58, 42),
    ),

    SeasonActiveIconBackground(
        hexLight = "#F5A623",
        rgbLight = rgb(245, 166, 35),
        hexDark = "#F5A623",
        rgbDark = rgb(245, 166, 35),
    ),

    SeasonActiveBadge(
        hexLight = "#10B981",
        rgbLight = rgb(16, 185, 129),
        hexDark = "#10B981",
        rgbDark = rgb(16, 185, 129),
    ),

    SeasonItemIconBackground(
        hexLight = "#FFF8E7",
        rgbLight = rgb(255, 248, 231),
        hexDark = "#252132",
        rgbDark = rgb(37, 33, 50),
    ),

    SeasonMutedText(
        hexLight = "#808080",
        rgbLight = rgb(245, 244, 237),
        hexDark = "#94979C",
        rgbDark = rgb(148, 151, 156),
    ),
    OffWhite(
        hexLight = "#fffff4",
        rgbLight = rgb(255,255,244),
        hexDark = "#94979C",
        rgbDark = rgb(148, 151, 156),
    ),
    CoachTalkPrimaryBlue(
        hexLight = "#2563EB",
        rgbLight = rgb(37, 99, 235),
        hexDark = "#2563EB",
        rgbDark = rgb(37, 99, 235),
    ),

    CoachTalkSuccessGreen(
        hexLight = "#16A34A",
        rgbLight = rgb(22, 163, 74),
        hexDark = "#16A34A",
        rgbDark = rgb(22, 163, 74),
    ),

    CoachTalkErrorRed(
        hexLight = "#DC2626",
        rgbLight = rgb(220, 38, 38),
        hexDark = "#DC2626",
        rgbDark = rgb(220, 38, 38),
    ),

    CoachTalkTableHeaderText(
        hexLight = "#6B7280",
        rgbLight = rgb(107, 114, 128),
        hexDark = "#6B7280",
        rgbDark = rgb(107, 114, 128),
    ),

    CoachTalkTableBorder(
        hexLight = "#E5E7EB",
        rgbLight = rgb(229, 231, 235),
        hexDark = "#E5E7EB",
        rgbDark = rgb(229, 231, 235),
    ),

    CoachTalkRowBorder(
        hexLight = "#F3F4F6",
        rgbLight = rgb(243, 244, 246),
        hexDark = "#F3F4F6",
        rgbDark = rgb(243, 244, 246),
    ),
    SessionIntensityGreen(
        hexLight = "#22C55E",
        rgbLight = rgb(34, 197, 94),
        hexDark = "#22C55E",
        rgbDark = rgb(34, 197, 94),
    ),

    GameRealismPurple(
        hexLight = "#9333EA",
        rgbLight = rgb(147, 51, 234),
        hexDark = "#9333EA",
        rgbDark = rgb(147, 51, 234),
    ),

    DevelopmentOrange(
        hexLight = "#F97316",
        rgbLight = rgb(249, 115, 22),
        hexDark = "#F97316",
        rgbDark = rgb(249, 115, 22),
    ),

    TacticalComplexityCyan(
        hexLight = "#06B6D4",
        rgbLight = rgb(6, 182, 212),
        hexDark = "#06B6D4",
        rgbDark = rgb(6, 182, 212),
    ),

    TopicDiversityPink(
        hexLight = "#EC4899",
        rgbLight = rgb(236, 72, 153),
        hexDark = "#EC4899",
        rgbDark = rgb(236, 72, 153),
    ),

    MethodologyBlue(
        hexLight = "#2563EB",
        rgbLight = rgb(37, 99, 235),
        hexDark = "#2563EB",
        rgbDark = rgb(37, 99, 235),
    ),

    CognitiveTrainingGreen(
        hexLight = "#22C55E",
        rgbLight = rgb(34, 197, 94),
        hexDark = "#22C55E",
        rgbDark = rgb(34, 197, 94),
    ),

    CompetitiveEnvironmentRed(
        hexLight = "#FF3B30",
        rgbLight = rgb(255, 59, 48),
        hexDark = "#FF3B30",
        rgbDark = rgb(255, 59, 48),
    ),
    DefensiveOrganizationRed(
        hexLight = "#EF4444",
        rgbLight = rgb(239, 68, 68),
        hexDark = "#EF4444",
        rgbDark = rgb(239, 68, 68),
    ),

    SetPieceEfficiencyAmber(
        hexLight = "#F59E0B",
        rgbLight = rgb(245, 158, 11),
        hexDark = "#F59E0B",
        rgbDark = rgb(245, 158, 11),
    ),
    WidgetAverageText(
        hexLight = "#3B6D11",
        rgbLight = rgb(59, 109, 17),
        hexDark = "#3B6D11",
        rgbDark = rgb(59, 109, 17),
    ),
    WidgetAverageBackground(
        hexLight = "#EAF3DE",
        rgbLight = rgb(234, 243, 222),
        hexDark = "#EAF3DE",
        rgbDark = rgb(234, 243, 222),
    ),
    DevelopmentAverage(
        hexLight = "#0F172A",
        rgbLight = rgb(15, 23, 42),
        hexDark = "#0F172A",
        rgbDark = rgb(15, 23, 42),
    ),
    BarColor(
        hexLight = "#D1D5DB",
        rgbLight = rgb(209, 213, 219),
        hexDark = "#D1D5DB",
        rgbDark = rgb(209, 213, 219),
    ),
    ViewDetailBackground(
        hexLight = "#F8FAFC",
        rgbLight = rgb(248, 250, 252),
        hexDark = "#F8FAFC",
        rgbDark = rgb(248, 250, 252),
    ),
    ViewDetailBorder(
        hexLight = "#E5E7EB",
        rgbLight = rgb(229, 231, 235),
        hexDark = "#E5E7EB",
        rgbDark = rgb(229, 231, 235),
    ),
    ViewDetailText(
        hexLight = "#1F2937",
        rgbLight = rgb(31, 41, 55),
        hexDark = "#1F2937",
        rgbDark = rgb(31, 41, 55),
    ),
    ViewDetailAngle(
        hexLight = "#6B7280",
        rgbLight = rgb(107, 114, 128),
        hexDark = "#6B7280",
        rgbDark = rgb(107, 114, 128),
    ),
    CardBorder(
        hexLight = "#DCDCDC",
        rgbLight = rgb(220, 220, 220),
        hexDark = "#DCDCDC",
        rgbDark = rgb(220, 220, 220),
    ),

}



class SitePalette(
    // top level colors
    val primary: ColorVariation,
    val bodyBackground: ColorVariation,
    val bodyBackgroundSecondary: ColorVariation,

    // Button Colors
    val specialButtonBorderColor: ColorVariation,
    val commonButtonBorderColor: ColorVariation,
    val commonSecondaryButtonColor: ColorVariation,
    val commonButtonSupportiveTextColor: ColorVariation,

    // Header colors
    val headerBackgroundColor: ColorVariation,
    val tablehHeaderBackgroundColor: ColorVariation,
    val coachHeaderDetails: ColorVariation,
    val coachHeaderGradientOne: ColorVariation,
    val coachHeaderGradientTwo: ColorVariation,
    val playerHeaderGradientOne: ColorVariation,
    val playerHeaderGradientTwo: ColorVariation,


    // Text Field Colors
    val textFieldTextColor: ColorVariation,
    val textFieldSupportiveTextColor: ColorVariation,
    val textFieldBorderColor: ColorVariation,
    val textFieldBorderColorDisabled: ColorVariation,
    val searchbarBorderColorPlaceholder: ColorVariation,
    val infoIconColor: ColorVariation,
    val primaryPosition: ColorVariation,

    // Modal Colors
    val modalBackgroundColor: ColorVariation,


    // Other Text Colors
    val textErrorColor: ColorVariation,
    val textRedColor: ColorVariation,
    val textGreenColor: ColorVariation,
    val clubPerformanceTextColor: ColorVariation,
    val fadedBlack: ColorVariation,
    val viewButtonBackground: ColorVariation,
    val viewText: ColorVariation,
    val sentButtonColor: ColorVariation,
    val sendButtonColor: ColorVariation,
    val coachInfoTextColor: ColorVariation,
    val titleColor: ColorVariation,
    val playerSavePngDataBox: ColorVariation,

//    Keyword Colors
    val technicalCategoryBackground: ColorVariation,
    val fitnessCategoryBackground: ColorVariation,
    val tacticalCategoryBackground: ColorVariation,
    val mentalCategoryBackground: ColorVariation,
    val goalKeeperCategoryBackground: ColorVariation,
    val technicalCategoryBorder: ColorVariation,
    val fitnessCategoryBorder: ColorVariation,
    val tacticalCategoryBorder: ColorVariation,
    val mentalCategoryBorder: ColorVariation,
    val goalKeeperCategoryBorder: ColorVariation,
//
    val coachesTitleRow: ColorVariation,
    val boxShadowColor: ColorVariation,
    val lightGrey: ColorVariation,
    val searchBackground: ColorVariation,
    val selectedSessionBackground: ColorVariation,
    val selectedSessionBackgroundBorder: ColorVariation,
    val coachDetailsBoxBorder: ColorVariation,
    val notificationBar: ColorVariation,
    val seasonActiveDot: ColorVariation,
    val seasonSearchBackground: ColorVariation,
    val seasonActiveCardBackground: ColorVariation,
    val seasonSunColor: ColorVariation,
    val seasonActiveBadge: ColorVariation,
    val seasonItemIconBackground: ColorVariation,
    val seasonMutedText: ColorVariation,
    ) {
    class ColorVariation(
        val hex: String,
        val rgb: Color.Rgb
    )
}

object SitePalettes {
    val light = SitePalette(
        // top level colors
        primary = SitePalette.ColorVariation(
            hex = Palette.Primary.hexLight,
            rgb = Palette.Primary.rgbLight
        ),
        bodyBackground = SitePalette.ColorVariation(
            hex = Palette.BodyBackground.hexLight,
            rgb = Palette.BodyBackground.rgbLight

        ),
        bodyBackgroundSecondary = SitePalette.ColorVariation(
            hex = Palette.White.hexLight,
            rgb = Palette.White.rgbLight

        ),
        // Button colors
        specialButtonBorderColor = SitePalette.ColorVariation(
            hex = Palette.ParrotGreen.hexLight,
            rgb = Palette.ParrotGreen.rgbLight

        ),
        commonButtonBorderColor = SitePalette.ColorVariation(
            hex = Palette.Primary.hexLight,
            rgb = Palette.Primary.rgbLight

        ),
        commonSecondaryButtonColor = SitePalette.ColorVariation(
            hex = Palette.Secondary.hexLight,
            rgb = Palette.Secondary.rgbLight

        ),
        commonButtonSupportiveTextColor = SitePalette.ColorVariation(
            hex = Palette.ButtonTextSupportive.hexLight,
            rgb = Palette.ButtonTextSupportive.rgbLight

        ),

        // Header colors

        headerBackgroundColor = SitePalette.ColorVariation(
            hex = Palette.Primary.hexLight,
            rgb = Palette.Primary.rgbLight

        ),

        tablehHeaderBackgroundColor = SitePalette.ColorVariation(
            hex = Palette.TableHeader.hexLight,
            rgb = Palette.TableHeader.rgbLight

        ),

        // Text Field colors
        textFieldTextColor = SitePalette.ColorVariation(
            hex = Palette.Black.hexLight,
            rgb = Palette.Black.rgbLight

        ),
        textFieldSupportiveTextColor = SitePalette.ColorVariation(
            hex = Palette.EditTextSupportText.hexLight,
            rgb = Palette.EditTextSupportText.rgbLight

        ),
        textFieldBorderColorDisabled = SitePalette.ColorVariation(
            hex = Palette.Disabled.hexLight,
            rgb = Palette.Disabled.rgbLight

        ),
        textFieldBorderColor = SitePalette.ColorVariation(
            hex = Palette.EditTextBorder.hexLight,
            rgb = Palette.EditTextBorder.rgbLight

        ),
        searchbarBorderColorPlaceholder = SitePalette.ColorVariation(
            hex = Palette.SearchbarPlaceholder.hexLight,
            rgb = Palette.SearchbarPlaceholder.rgbLight

        ),

        // Modal background color
        modalBackgroundColor = SitePalette.ColorVariation(
            hex = Palette.Modal.hexLight,
            rgb = Palette.Modal.rgbLight

        ),

        // Other text colors
        textErrorColor = SitePalette.ColorVariation(
            hex = Palette.Error.hexLight,
            rgb = Palette.Error.rgbLight

        ),

        textRedColor = SitePalette.ColorVariation(
            hex = Palette.DeleteRed.hexLight,
            rgb = Palette.DeleteRed.rgbLight

        ),
        textGreenColor = SitePalette.ColorVariation(
            hex = Palette.Success.hexLight,
            rgb = Palette.Success.rgbLight

        ),
        fadedBlack = SitePalette.ColorVariation(
            hex = Palette.FadedBlack.hexLight,
            rgb = Palette.FadedBlack.rgbLight
        ),
       technicalCategoryBackground = SitePalette.ColorVariation(
            hex = Palette.TechnicalCategoryBackground.hexLight,
            rgb = Palette.TechnicalCategoryBackground.rgbLight
        ),
        fitnessCategoryBackground = SitePalette.ColorVariation(
            hex = Palette.FitnessCategoryBackground.hexLight,
            rgb = Palette.FitnessCategoryBackground.rgbLight
        ),
        tacticalCategoryBackground = SitePalette.ColorVariation(
            hex = Palette.TacticalCategoryBackground.hexLight,
            rgb = Palette.TacticalCategoryBackground.rgbLight
        ),
        mentalCategoryBackground = SitePalette.ColorVariation(
            hex = Palette.MentalCategoryBackground.hexLight,
            rgb = Palette.MentalCategoryBackground.rgbLight
        ),
        goalKeeperCategoryBackground = SitePalette.ColorVariation(
            hex = Palette.GoalKeeperCategoryBackground.hexLight,
            rgb = Palette.GoalKeeperCategoryBackground.rgbLight
        ),
       technicalCategoryBorder = SitePalette.ColorVariation(
            hex = Palette.TechnicalCategoryBorder.hexLight,
            rgb = Palette.TechnicalCategoryBorder.rgbLight
        ),
        fitnessCategoryBorder = SitePalette.ColorVariation(
            hex = Palette.FitnessCategoryBorder.hexLight,
            rgb = Palette.FitnessCategoryBorder.rgbLight
        ),
        tacticalCategoryBorder = SitePalette.ColorVariation(
            hex = Palette.TacticalCategoryBorder.hexLight,
            rgb = Palette.TacticalCategoryBorder.rgbLight
        ),
        mentalCategoryBorder = SitePalette.ColorVariation(
            hex = Palette.MentalCategoryBorder.hexLight,
            rgb = Palette.MentalCategoryBorder.rgbLight
        ),
        goalKeeperCategoryBorder = SitePalette.ColorVariation(
            hex = Palette.GoalKeeperCategoryBorder.hexLight,
            rgb = Palette.GoalKeeperCategoryBorder.rgbLight
        ),
        clubPerformanceTextColor = SitePalette.ColorVariation(
            hex = Palette.ClubPerformanceText.hexLight,
            rgb = Palette.ClubPerformanceText.rgbLight
        ),
        coachesTitleRow = SitePalette.ColorVariation(
            hex = Palette.CoachesTileRow.hexLight,
            rgb = Palette.CoachesTileRow.rgbLight
        ),
        viewButtonBackground = SitePalette.ColorVariation(
            hex = Palette.ViewButtonBackground.hexLight,
            rgb = Palette.ViewButtonBackground.rgbLight
        ),
        viewText = SitePalette.ColorVariation(
            hex = Palette.ViewText.hexLight,
            rgb = Palette.ViewText.rgbLight
        ),
        sentButtonColor = SitePalette.ColorVariation(
            hex = Palette.SentButtonColor.hexLight,
            rgb = Palette.SentButtonColor.rgbLight
            ),
        sendButtonColor = SitePalette.ColorVariation(
            hex = Palette.SendButtonColor.hexLight,
            rgb = Palette.SendButtonColor.rgbLight
        ),
        boxShadowColor = SitePalette.ColorVariation(
            hex = Palette.BoxShadowColor.hexLight,
            rgb = Palette.BoxShadowColor.rgbLight
        ),
        coachInfoTextColor = SitePalette.ColorVariation(
            hex = Palette.CoachInfoTextColor.hexLight,
            rgb = Palette.CoachInfoTextColor.rgbLight
        ),
        lightGrey = SitePalette.ColorVariation(
            hex = Palette.LightGrey.hexLight,
            rgb = Palette.LightGrey.rgbLight
        ),
        searchBackground = SitePalette.ColorVariation(
            hex = Palette.SearchBackground.hexLight,
            rgb = Palette.SearchBackground.rgbLight
        ),
        selectedSessionBackground = SitePalette.ColorVariation(
            hex = Palette.SelectedSessionBackground.hexLight,
            rgb = Palette.SelectedSessionBackground.rgbLight
        ),
        coachDetailsBoxBorder = SitePalette.ColorVariation(
            hex = Palette.CoachDetailsBoxBorder.hexLight,
            rgb = Palette.CoachDetailsBoxBorder.rgbLight
        ),
        titleColor = SitePalette.ColorVariation(
            hex = Palette.TitleColor.hexLight,
            rgb = Palette.TitleColor.rgbLight
        ),
        coachHeaderDetails = SitePalette.ColorVariation(
            hex = Palette.CoachHeaderDetails.hexLight,
            rgb = Palette.CoachHeaderDetails.rgbLight
        ),
        coachHeaderGradientOne = SitePalette.ColorVariation(
            hex = Palette.CoachHeaderGradientOne.hexLight,
            rgb = Palette.CoachHeaderGradientOne.rgbLight
        ),
        coachHeaderGradientTwo = SitePalette.ColorVariation(
            hex = Palette.CoachHeaderGradientTwo.hexLight,
            rgb = Palette.CoachHeaderGradientTwo.rgbLight
        ),
        playerHeaderGradientOne = SitePalette.ColorVariation(
            hex = Palette.PlayerHeaderGradientOne.hexLight,
            rgb = Palette.PlayerHeaderGradientOne.rgbLight
        ),
        playerHeaderGradientTwo = SitePalette.ColorVariation(
            hex = Palette.PlayerHeaderGradientTwo.hexLight,
            rgb = Palette.PlayerHeaderGradientTwo.rgbLight
        ),
        infoIconColor = SitePalette.ColorVariation(
            hex = Palette.InfoIconColor.hexLight,
            rgb = Palette.InfoIconColor.rgbLight
        ),
        primaryPosition = SitePalette.ColorVariation(
            hex = Palette.PrimaryPosition.hexLight,
            rgb = Palette.PrimaryPosition.rgbLight
        ),
        playerSavePngDataBox = SitePalette.ColorVariation(
            hex = Palette.PlayerSavePngDataBox.hexLight,
            rgb = Palette.PlayerSavePngDataBox.rgbLight
        ),
        notificationBar = SitePalette.ColorVariation(
            hex = Palette.NotificationBar.hexLight,
            rgb = Palette.NotificationBar.rgbLight
        ),
        seasonActiveDot = SitePalette.ColorVariation(
            Palette.SeasonActiveDot.hexLight,
            Palette.SeasonActiveDot.rgbLight
        ),

        seasonSearchBackground = SitePalette.ColorVariation(
            Palette.SeasonSearchBackground.hexLight,
            Palette.SeasonSearchBackground.rgbLight
        ),

        seasonActiveCardBackground = SitePalette.ColorVariation(
            Palette.SeasonActiveCardBackground.hexLight,
            Palette.SeasonActiveCardBackground.rgbLight
        ),

        seasonSunColor = SitePalette.ColorVariation(
            Palette.SeasonActiveIconBackground.hexLight,
            Palette.SeasonActiveIconBackground.rgbLight
        ),

        seasonActiveBadge = SitePalette.ColorVariation(
            Palette.SeasonActiveBadge.hexLight,
            Palette.SeasonActiveBadge.rgbLight
        ),

        seasonItemIconBackground = SitePalette.ColorVariation(
            Palette.SeasonItemIconBackground.hexLight,
            Palette.SeasonItemIconBackground.rgbLight
        ),

        seasonMutedText = SitePalette.ColorVariation(
            Palette.SeasonMutedText.hexLight,
            Palette.SeasonMutedText.rgbLight
        ),
        selectedSessionBackgroundBorder = SitePalette.ColorVariation(
            hex = Palette.SelectedSessionBackgroundBorder.hexLight,
            rgb = Palette.SelectedSessionBackgroundBorder.rgbLight
        )

    )

    val dark = SitePalette(
        // top level colors
        primary = SitePalette.ColorVariation(
            hex = Palette.Primary.hexDark,
            rgb = Palette.Primary.rgbDark
        ),
        bodyBackground = SitePalette.ColorVariation(
            hex = Palette.BodyBackground.hexDark,
            rgb = Palette.BodyBackground.rgbDark

        ),
        bodyBackgroundSecondary = SitePalette.ColorVariation(
            hex = Palette.BodyBackground.hexDark,
            rgb = Palette.BodyBackground.rgbDark

        ),

        // Button colors
        specialButtonBorderColor = SitePalette.ColorVariation(
            hex = Palette.Primary.hexDark,
            rgb = Palette.Primary.rgbDark

        ),
        commonButtonBorderColor = SitePalette.ColorVariation(
            hex = Palette.Primary.hexDark,
            rgb = Palette.Primary.rgbDark

        ),
        commonSecondaryButtonColor = SitePalette.ColorVariation(
            hex = Palette.Secondary.hexDark,
            rgb = Palette.Secondary.rgbDark

        ),
        commonButtonSupportiveTextColor = SitePalette.ColorVariation(
            hex = Palette.ButtonTextSupportive.hexDark,
            rgb = Palette.ButtonTextSupportive.rgbDark

        ),

        // Header colors

        headerBackgroundColor = SitePalette.ColorVariation(
            hex = Palette.BodyBackground.hexDark,
            rgb = Palette.BodyBackground.rgbDark

        ),

        tablehHeaderBackgroundColor = SitePalette.ColorVariation(
            hex = Palette.TableHeader.hexDark,
            rgb = Palette.TableHeader.rgbDark

        ),


        // Text Field colors
        textFieldTextColor = SitePalette.ColorVariation(
            hex = Palette.White.hexDark,
            rgb = Palette.White.rgbDark

        ),
        textFieldSupportiveTextColor = SitePalette.ColorVariation(
            hex = Palette.EditTextSupportText.hexDark,
            rgb = Palette.EditTextSupportText.rgbDark

        ),
        textFieldBorderColorDisabled = SitePalette.ColorVariation(
            hex = Palette.Disabled.hexDark,
            rgb = Palette.Disabled.rgbDark

        ),
        textFieldBorderColor = SitePalette.ColorVariation(
            hex = Palette.EditTextBorder.hexDark,
            rgb = Palette.EditTextBorder.rgbDark

        ),
        searchbarBorderColorPlaceholder = SitePalette.ColorVariation(
            hex = Palette.SearchbarPlaceholder.hexDark,
            rgb = Palette.SearchbarPlaceholder.rgbDark

        ),

        // Modal background color
        modalBackgroundColor = SitePalette.ColorVariation(
            hex = Palette.Modal.hexDark,
            rgb = Palette.Modal.rgbDark

        ),

        // Other text colors
        textErrorColor = SitePalette.ColorVariation(
            hex = Palette.Error.hexDark,
            rgb = Palette.Error.rgbDark

        ),

        textRedColor = SitePalette.ColorVariation(
            hex = Palette.DeleteRed.hexDark,
            rgb = Palette.DeleteRed.rgbDark

        ),
        textGreenColor = SitePalette.ColorVariation(
            hex = Palette.Success.hexDark,
            rgb = Palette.Success.rgbDark

        ),
        fadedBlack = SitePalette.ColorVariation(
            hex = Palette.FadedBlack.hexDark,
            rgb = Palette.FadedBlack.rgbDark
        ),
       technicalCategoryBackground = SitePalette.ColorVariation(
            hex = Palette.TechnicalCategoryBackground.hexDark,
            rgb = Palette.TechnicalCategoryBackground.rgbDark
        ),
        fitnessCategoryBackground = SitePalette.ColorVariation(
            hex = Palette.FitnessCategoryBackground.hexDark,
            rgb = Palette.FitnessCategoryBackground.rgbDark
        ),
        tacticalCategoryBackground = SitePalette.ColorVariation(
            hex = Palette.TacticalCategoryBackground.hexDark,
            rgb = Palette.TacticalCategoryBackground.rgbDark
        ),
        mentalCategoryBackground = SitePalette.ColorVariation(
            hex = Palette.MentalCategoryBackground.hexDark,
            rgb = Palette.MentalCategoryBackground.rgbDark
        ),
        goalKeeperCategoryBackground = SitePalette.ColorVariation(
            hex = Palette.GoalKeeperCategoryBackground.hexDark,
            rgb = Palette.GoalKeeperCategoryBackground.rgbDark
        ),
       technicalCategoryBorder = SitePalette.ColorVariation(
            hex = Palette.TechnicalCategoryBackground.hexDark,
            rgb = Palette.TechnicalCategoryBorder.rgbDark
        ),
        fitnessCategoryBorder = SitePalette.ColorVariation(
            hex = Palette.FitnessCategoryBorder.hexDark,
            rgb = Palette.FitnessCategoryBorder.rgbDark
        ),
        tacticalCategoryBorder = SitePalette.ColorVariation(
            hex = Palette.TacticalCategoryBorder.hexDark,
            rgb = Palette.TacticalCategoryBorder.rgbDark
        ),
        mentalCategoryBorder = SitePalette.ColorVariation(
            hex = Palette.MentalCategoryBorder.hexDark,
            rgb = Palette.MentalCategoryBorder.rgbDark
        ),
        goalKeeperCategoryBorder = SitePalette.ColorVariation(
            hex = Palette.GoalKeeperCategoryBorder.hexDark,
            rgb = Palette.GoalKeeperCategoryBorder.rgbDark
        ),
        clubPerformanceTextColor = SitePalette.ColorVariation(
            hex = Palette.ClubPerformanceText.hexDark,
            rgb = Palette.ClubPerformanceText.rgbDark
        ),
        coachesTitleRow = SitePalette.ColorVariation(
            hex = Palette.CoachesTileRow.hexDark,
            rgb = Palette.CoachesTileRow.rgbDark
        ),
        viewButtonBackground = SitePalette.ColorVariation(
            hex = Palette.ViewButtonBackground.hexDark,
            rgb = Palette.ViewButtonBackground.rgbDark
        ),
        viewText = SitePalette.ColorVariation(
            hex = Palette.ViewText.hexDark,
            rgb = Palette.ViewText.rgbDark
        ),
        sentButtonColor = SitePalette.ColorVariation(
            hex = Palette.SentButtonColor.hexDark,
            rgb = Palette.SentButtonColor.rgbDark
        ),
        sendButtonColor = SitePalette.ColorVariation(
            hex = Palette.SendButtonColor.hexDark,
            rgb = Palette.SendButtonColor.rgbDark
        ),
        boxShadowColor = SitePalette.ColorVariation(
            hex = Palette.BoxShadowColor.hexDark,
            rgb = Palette.BoxShadowColor.rgbDark
       ),
        coachInfoTextColor = SitePalette.ColorVariation(
            hex = Palette.CoachInfoTextColor.hexDark,
            rgb = Palette.CoachInfoTextColor.rgbDark
        ),
        lightGrey = SitePalette.ColorVariation(
            hex = Palette.LightGrey.hexDark,
            rgb = Palette.LightGrey.rgbDark
        ),
        searchBackground = SitePalette.ColorVariation(
            hex = Palette.SearchBackground.hexDark,
            rgb = Palette.SearchBackground.rgbDark
        ),
        selectedSessionBackground = SitePalette.ColorVariation(
            hex = Palette.SelectedSessionBackground.hexDark,
            rgb = Palette.SelectedSessionBackground.rgbDark
        ),
        coachDetailsBoxBorder = SitePalette.ColorVariation(
            hex = Palette.CoachDetailsBoxBorder.hexDark,
            rgb = Palette.CoachDetailsBoxBorder.rgbDark
        ),
        titleColor = SitePalette.ColorVariation(
            hex = Palette.TitleColor.hexDark,
            rgb = Palette.TitleColor.rgbDark
                ),
        coachHeaderDetails = SitePalette.ColorVariation(
            hex = Palette.CoachHeaderDetails.hexDark,
            rgb = Palette.CoachHeaderDetails.rgbDark
        ),
        coachHeaderGradientOne = SitePalette.ColorVariation(
            hex = Palette.CoachHeaderGradientOne.hexDark,
            rgb = Palette.CoachHeaderGradientOne.rgbDark
        ),

        coachHeaderGradientTwo = SitePalette.ColorVariation(
            hex = Palette.CoachHeaderGradientTwo.hexDark,
            rgb = Palette.CoachHeaderGradientTwo.rgbDark
        ),
        playerHeaderGradientOne = SitePalette.ColorVariation(
            hex = Palette.PlayerHeaderGradientOne.hexDark,
            rgb = Palette.PlayerHeaderGradientOne.rgbDark
        ),
        playerHeaderGradientTwo = SitePalette.ColorVariation(
            hex = Palette.PlayerHeaderGradientTwo.hexDark,
            rgb = Palette.PlayerHeaderGradientTwo.rgbDark
        ),
        infoIconColor = SitePalette.ColorVariation(
            hex = Palette.InfoIconColor.hexDark,
            rgb = Palette.InfoIconColor.rgbDark
        ),
        primaryPosition = SitePalette.ColorVariation(
            hex = Palette.PrimaryPosition.hexDark,
            rgb = Palette.PrimaryPosition.rgbDark
        ),
        playerSavePngDataBox = SitePalette.ColorVariation(
            hex = Palette.PlayerSavePngDataBox.hexDark,
            rgb = Palette.PlayerSavePngDataBox.rgbDark
        ),
        notificationBar = SitePalette.ColorVariation(
            hex = Palette.NotificationBar.hexDark,
            rgb = Palette.NotificationBar.rgbDark
        ),
        seasonActiveDot = SitePalette.ColorVariation(
            Palette.SeasonActiveDot.hexDark,
            Palette.SeasonActiveDot.rgbDark
        ),

        seasonSearchBackground = SitePalette.ColorVariation(
            Palette.SeasonSearchBackground.hexDark,
            Palette.SeasonSearchBackground.rgbDark
        ),

        seasonActiveCardBackground = SitePalette.ColorVariation(
            Palette.SeasonActiveCardBackground.hexDark,
            Palette.SeasonActiveCardBackground.rgbDark
        ),

        seasonSunColor = SitePalette.ColorVariation(
            Palette.SeasonActiveIconBackground.hexDark,
            Palette.SeasonActiveIconBackground.rgbDark
        ),

        seasonActiveBadge = SitePalette.ColorVariation(
            Palette.SeasonActiveBadge.hexDark,
            Palette.SeasonActiveBadge.rgbDark
        ),

        seasonItemIconBackground = SitePalette.ColorVariation(
            Palette.SeasonItemIconBackground.hexDark,
            Palette.SeasonItemIconBackground.rgbDark
        ),

        seasonMutedText = SitePalette.ColorVariation(
            Palette.SeasonMutedText.hexDark,
            Palette.SeasonMutedText.rgbDark
        ),
        selectedSessionBackgroundBorder = SitePalette.ColorVariation(
            hex = Palette.SelectedSessionBackgroundBorder.hexDark,
            rgb = Palette.SelectedSessionBackgroundBorder.rgbDark
        )
    )
}

fun ColorMode.toSitePalette(): SitePalette {
    return when (this) {
        ColorMode.LIGHT -> SitePalettes.light
        ColorMode.DARK -> SitePalettes.dark
    }
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.light.background = Palette.BodyBackground.rgbLight
    ctx.theme.palettes.light.color = Colors.Black
    ctx.theme.palettes.dark.background = Palette.BodyBackground.rgbDark
    ctx.theme.palettes.dark.color = Colors.White
}

val AvatarColors = listOf(
    Color.rgb(239, 246, 255) to Color.rgb(29, 78, 216),   // blue
    Color.rgb(254, 249, 195) to Color.rgb(133, 77, 14),   // yellow
    Color.rgb(240, 253, 244) to Color.rgb(21, 128, 61),   // green
    Color.rgb(253, 244, 255) to Color.rgb(126, 34, 206),  // purple
    Color.rgb(255, 241, 242) to Color.rgb(190, 18, 60),   // pink
    Color.rgb(236, 253, 245) to Color.rgb(6, 95, 70),     // teal
    Color.rgb(255, 247, 237) to Color.rgb(154, 52, 18),   // orange
)